import React from 'react';
import Box from '@hitagi/core/Box';

export default function MenuContent(props) {
  return <Box padding={2} minWidth={300} {...props} />;
}
